/**
 * Created by 马荣钦 on 2016/1/21.
 */
'use strict';
angular.module('myZonePerInfoChangePwdModule', ['myZonePerInfoforgetPwModule']).controller('myZonePerInfoChangePwdCtrl', [
    '$scope',
    '$validation',
    '$state',
    '$q',
    'trsHttpService',
    'modalDialog',
    'globleParamsSet',
    function($scope, $validation, $state, $q, trsHttpService, modalDialog, globleParamsSet) {
        initStatus();
        initData();

        function initData() {
            requestData();
            headPortrait();
        }

        /**
         * [headPortrait description] 获取头像
         * @return {[type]} [description]
         */
        function headPortrait() {
            var headParams = {
                serviceid: 'mlf_extuser',
                methodname: 'getUserHeadPic',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), headParams, 'get').then(function(data) {
                $scope.headPic = data.USERHEAD[0].PERPICURL == '' ? './images/user_icon.jpg' : data.USERHEAD[0].PERPICURL;
            });
        }

        function initStatus() {
            $scope.params = {
                serviceid: 'mlf_extuser',
                methodname: 'getCurrUserInfo',
            };
            $scope.status = {
                tip: true,
            };
        }

        function requestData() {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.info = data;
            });
        }

        /**
         * [savePwd description]  保存
         * @return {[type]} [description]
         */
        $scope.savePwd = function() {
            $validation.validate($scope.changePwdForm).success(function() {
                if ($scope.newPwdTwo != $scope.newPwd) {
                    modalDialog.alertType('确认密码与新密码不一致', '', 'error', false, '');
                    return;
                }
                var params = {
                    serviceid: 'mlf_extuser',
                    methodname: 'resetPassword',
                    UserName: $scope.info.USERNAME,
                    OldPassword: $scope.oldPwd,
                    NewPassword: $scope.newPwd,
                    NewPasswordTwo: $scope.newPwdTwo,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    modalDialog.alertType('密码修改成功', '', 'success', false);
                    $scope.oldPwd = '';
                    $scope.newPwd = '';
                    $scope.newPwdTwo = '';
                });
            });
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $scope.oldPwd = '';
            $scope.newPwd = '';
            $scope.newPwdTwo = '';
        };

        /**
         * [checkPwd description] 校验两次密码是否一致
         * @return {[type]} [description]
         */
        $scope.checkPwd = function() {
            $scope.status.tip = $scope.newPwd == $scope.newPwdTwo;
        };

        /**
         * [toIDS description] 忘记密码跳转到ids
         * @return {[type]} [description]
         */
        $scope.toIDS = function() {
            globleParamsSet.getTenantLogo().then(function(data) {
                getMd5().then(function(SparkMD5) {
                    var curr = new Date();
                    var crTime = new Date(curr.setSeconds(curr.getSeconds() + 4)).getTime();
                    var token = crTime + 'restpwd';
                    token = SparkMD5.hash(token);
                    var host = window.location.host;
                    var url = '';
                    if (host == '10.200.77.111') {
                        url = 'http://10.200.77.111:8080';
                    } else if (host == 'csi.tmuyun.com') {
                        url = 'http://cssso.tmuyun.com';
                    } else {
                        url = 'http://sso.tmuyun.com';
                    }
                    if (data.LOGO_2 == './images/logo_2.png') {
                        data.LOGO_2 = 'false';
                    }
                    var iconUrl = encodeURIComponent(data.LOGO_2);
                    url =
                        url +
                        '/ids/admin/userhome/tianmuyunForgetPwdSendMessageToTelOrEmail.jsp?username=' +
                        $scope.info.USERNAME +
                        '&fromWeb=GlobalLoginPage' +
                        '&token=' +
                        token +
                        '&crTime=' +
                        crTime +
                        '&iconUrl=' +
                        iconUrl;
                    window.open(url);
                });
            });
        };

        function getMd5() {
            var deffer = $q.defer();
            require(['./lib/js-spark-md5-master/spark-md5.min'], function(SparkMD5) {
                deffer.resolve(SparkMD5);
            });

            return deffer.promise;
        }
    },
]);
